// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2ZTyc","col":"Table_col__19mH4","fulfillmentStatus":"Table_fulfillmentStatus__3puZH","emailCol":"Table_emailCol__2Nb9s"};